module.exports = __webpack_public_path__ + "img/home-banner-mob.a916f45.webp";